// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/kimi-coding.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const KIMI_CODING_MODELS: ModelCatalog<typeof values, "kimi-coding"> =
	flattenModelCatalog("kimi-coding", values);
